export enum GTMIdentifierTypes {
  ActiveAccount = 'activate_account_aupair',
}
